var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"btn-position",on:{"click":function($event){return _vm.handlerGoMap('1')}}}),_c('span',{staticClass:"btn-360",on:{"click":function($event){return _vm.handlerGoMap('2')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }